import * as Icon from 'react-feather';
import { ButtonProps } from 'antd';
import { colorTableOperationIcon } from '@atlas-frontend/design-tokens';
import { TableOperationButton } from '../TableOperationButton';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './CloneTableRowButton.translations.json';
import { CellContext } from '@tanstack/react-table';

const { addTranslations, useTranslation } = i18nNsFactory(
  'clone-table-row-button'
);
addTranslations(translations);

export interface CloneTableRowButtonProps extends Omit<ButtonProps, 'id'> {
  id?: string;
  context: CellContext<any, any>;
  resetId?: boolean;
  autoFocusField?: string;
}

export const CloneTableRowButton = (props: CloneTableRowButtonProps) => {
  const { t } = useTranslation();
  const {
    title = t('button.clone'),
    onClick,
    context,
    id = `clone-table-row-${context.row.index}`,
    resetId,
    autoFocusField,
    ...rest
  } = props;

  return (
    <TableOperationButton
      id={id}
      title={title}
      icon={<Icon.Copy size={18} color={colorTableOperationIcon} />}
      type="text"
      onClick={onClick}
      aria-label={title}
      {...rest}
    />
  );
};
